export default {}


// WEBPACK FOOTER //
// ./src/i18n/ja/about/common.js